var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "exception" }, [
    _c("div", { staticClass: "imgBlock" }, [
      _c("div", {
        staticClass: "imgEle",
        style: {
          backgroundImage: "url(" + (_vm.img || _vm.config[_vm.type].img) + ")"
        }
      })
    ]),
    _c("div", { staticClass: "content" }, [
      _c("h1", [_vm._v(_vm._s(_vm.title || _vm.config[_vm.type].title))]),
      _vm.desc
        ? _c("div", {
            staticClass: "desc",
            domProps: { innerHTML: _vm._s(_vm.desc) }
          })
        : _c("div", { staticClass: "desc" }, [
            _vm._v(_vm._s(_vm.config[_vm.type].desc))
          ]),
      _c(
        "div",
        { staticClass: "actions" },
        [
          _vm.$slots.actions
            ? _vm._t("actions")
            : _c(
                "router-link",
                { attrs: { to: "/" } },
                [_c("el-button", [_vm._v("返回首页")])],
                1
              )
        ],
        2
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }